import {
  Component,
  OnInit,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';

import { CommonService } from '@services/common.service';
import { YTBSEOService } from '@services/ytb-seo.service';

@Component({
    selector: "app-sitemaintainance",
    templateUrl: "./SiteMaintainance.component.html"
})
export class SiteMaintainanceComponent implements OnInit {
    isLoading: boolean = true;

    constructor(
        private router: Router, private route: ActivatedRoute, private commonService: CommonService,private ytb:YTBSEOService) {

    }

    ngOnInit() {
        this.route.queryParams.subscribe(res => {
            let url = this.router.url.split('?');
            setTimeout(() => {
      
              this.ytb.createCanonicalURL(this.router.url);
              this.ytb.setDynamicTitle(url[0], { Maintainance: 'Maintainance' });
              this.ytb.updateMetaTags(
                'desc',
                { 'replaceKeywords': { 'Maintainance': 'Maintainance' } },
                'Homepage');
            }, 1000);
      
          });
    }

}